import React from 'react'
import Select from 'react-select';
const DepbDetails = () => {
    const basicDutyOpt = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    const basicUnit = [
        { value: 'Plus', label: 'Plus' },
        { value: 'Minus', label: 'Minus' },
        { value: 'Higher', label: 'Higher' },
        { value: 'Lower', label: 'Lower' },
    ]
    return (
        <div className='card'>
            <div className="card-body">
                <form>
                    <div className="row">



                        <div className="col-md-3 col-6">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Product Group
                                    </label>
                                </div>

                                <Select
                                    className='custom-selector w-auto'
                                    options={basicDutyOpt}
                                />

                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Rate List Sr. No.
                                    </label>
                                </div>

                                <Select
                                    className='custom-selector w-auto'
                                    options={basicDutyOpt}
                                />

                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        DEPB Rate
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm "
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                </div>
                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>


                        <div className="col-md-3 col-6">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Std I/O No.
                                    </label>

                                </div>

                                <input
                                    type="text"
                                    className="form-control form-control-sm "
                                    id="name"
                                    name="name"
                                    defaultValue="0.00"
                                />


                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-end mt-3 gap-2">
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & New
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Close
                        </button>

                    </div>


                </form>
            </div>
        </div>
    )
}

export default DepbDetails